import type { State } from "@/store/types";
import { getVisualBuilderMode } from "@/utils/visualBuilder";

import type { VisualBuilderModeResult } from "./types";

export interface VisualBuilderDataSelectorParams {
  propertyId?: string | number | null;
  experienceId?: string | number;
  userId?: string | number;
  tabStatus?: string;
  shareId?: string | number | null;
  mediaItemId?: string | number;
  mediaId?: string | number;
  asset?: string | number;
}

export const visualBuilderDataSelector = (params: VisualBuilderDataSelectorParams) => (state: State) => {
  const { key } = getVisualBuilderMode(params) as VisualBuilderModeResult;

  return {
    visualBuilderData: state.visualBuilderData[key] || {},
  };
};
